import { Seperator, StyledImg } from "./styles";
import logos from "../../assets/images/logos_stripe.png";

function Icons() {
  return <StyledImg src={logos} />;
}

export default Icons;
